import { render, staticRenderFns } from "./DotMenuItem.vue?vue&type=template&id=4b350090&scoped=true&"
import script from "./DotMenuItem.vue?vue&type=script&lang=js&"
export * from "./DotMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./DotMenuItem.vue?vue&type=style&index=0&id=4b350090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b350090",
  null
  
)

export default component.exports